export { default } from './GamePacman'
